import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel } from "./Carousel.js";
import { Stack } from "./Stack.js";
export function ListLayout({ variant, children, as, carousel, ...rest }) {
    const Component = as ?? "ul";
    if (variant === "carousel")
        return (_jsx(Carousel, { as: Component, ...carousel, ...rest, children: children }));
    if (variant === "grid")
        return (_jsx(Stack, { variant: "grid", ...rest, as: Component, children: children }));
}
